import { IOffer } from '../../types/offers';

export const getOfferLayout = (offer: IOffer) => {
  switch (offer.layout) {
    case 'mixed':
      return 'смешанная';
    case 'cabinet':
      return 'кабинетная';
    case 'openSpace':
      return 'открытая';
    default:
      return undefined;
  }
};
